import { render, staticRenderFns } from "./AddSocialCard.vue?vue&type=template&id=4233d3b8&scoped=true"
import script from "./AddSocialCard.vue?vue&type=script&lang=js"
export * from "./AddSocialCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4233d3b8",
  null
  
)

export default component.exports